import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const MAX_INFOS_LENGTH = 25

function trimString(str, length) {
  return str.substring(0, length) + (str.length > length ? '...' : '')
}

export const UserMention = ({ username }) => (
  <span className={classNames('entity-highlight font-weight-medium')}>
    {trimString(`@${username}`, MAX_INFOS_LENGTH)}
  </span>
)

UserMention.propTypes = {
  username: PropTypes.string.isRequired,
}

export default UserMention
